// M9: REACT_APP_API_URL 우선, 없으면 동일 호스트(:4000) 자동 추정,
// 그래도 안 되면 localhost:4000 (개발용 기본값)
const API_BASE = (() => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL.replace(/\/$/, '') + '/api';
  if (typeof window !== 'undefined' && window.location.hostname && window.location.hostname !== 'localhost') {
    return `${window.location.protocol}//${window.location.hostname}:4000/api`;
  }
  return 'http://localhost:4000/api';
})();
// 업로드된 파일의 상대경로 URL 을 절대경로로 변환할 때 사용 (M9)
export const API_ORIGIN = API_BASE.replace(/\/api$/, '');

// 401 이 오면 토큰 만료/위조로 보고 자동 로그아웃 후 로그인 페이지로 보냄
function handleAuthExpired() {
  if (localStorage.getItem('token')) {
    localStorage.removeItem('token');
    // /login 으로 한 번만 리다이렉트 (이미 로그인 페이지면 무시)
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      window.location.replace('/login?expired=1');
    }
  }
}

async function request(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  // 응답 본문이 JSON 이 아닐 가능성 (502/network 에러 페이지 등) 도 대비
  let data = null;
  try { data = await res.json(); } catch (e) { data = null; }

  if (res.status === 401) {
    handleAuthExpired();
    throw new Error(data?.error || '세션이 만료되었습니다. 다시 로그인하세요.');
  }
  if (!res.ok) {
    throw new Error(data?.error || '요청에 실패했습니다.');
  }
  return data;
}

async function downloadBlob(path, fallbackFilename) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}${path}`, { headers: { 'Authorization': `Bearer ${token}` } });
  if (res.status === 401) { handleAuthExpired(); throw new Error('세션이 만료되었습니다.'); }
  if (!res.ok) { const err = await res.json().catch(()=>({})); throw new Error(err.error || 'Download failed'); }
  // 서버 Content-Disposition에서 파일명 추출
  const cd = res.headers.get('Content-Disposition') || '';
  let filename = fallbackFilename;
  const utf8Match = cd.match(/filename\*=UTF-8''(.+)/i);
  if (utf8Match) filename = decodeURIComponent(utf8Match[1]);
  else { const match = cd.match(/filename="?([^";\n]+)"?/i); if (match) filename = match[1]; }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // 일부 브라우저(특히 모바일/Safari) 는 click 처리 전에 URL 이 revoke 되면 다운로드를 취소
  // → DOM 제거 + revoke 를 짧은 지연 후 실행
  setTimeout(() => { a.remove(); URL.revokeObjectURL(url); }, 500);
}

const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  put: (path, body) => request(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path, body) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  del: (path, body) => request(path, { method: 'DELETE', body: body ? JSON.stringify(body) : undefined }),
  download: downloadBlob,
};

export default api;
